import { Axios } from "../axios";
import { IAuth } from "../auth/auth";
import UserDetailsProps from "./userDetails";

const getUserTransaction = async (currentUser: IAuth.IIsAuthorisedProps) => {
  const vendorUserDetails = JSON.parse(localStorage.getItem("vendorUserDetails") || "{}");
  await Axios.get(`/remit/user/${vendorUserDetails.userKey}/transaction/getTransactionHistory`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

const getUserDocs = async (currentUser: IAuth.IIsAuthorisedProps) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  return await Axios.get(`/remit/users/${vendorUserKey}/documents`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

const getUserRecepients = async (body: IAuth.IRecipientProps) => {
  const vendorUserkey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const { page, size, ascending, filter, purposeCode, currency } = body;

  return await Axios.get(`/remit/user/${vendorUserkey}/listOfRecipients`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
    params: {
      page: page,
      size: size,
      ascending: ascending,
      filter: filter,
      purposeCode: purposeCode,
      currency: currency,
    },
  });
};

const getUserDetails = async (body: UserDetailsProps.UserDetailProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  if (currentUser !== null || currentUser !== undefined) {
    return await Axios.put(`remit/auth/user/${vendorUserKey}`, body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

const getRemitterDetails = async (currentUser: IAuth.IIsAuthorisedProps) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/auth/user/${vendorUserKey}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export { getUserTransaction, getUserDocs, getUserRecepients, getUserDetails, getRemitterDetails };
